import { render, staticRenderFns } from "./WidgetsDialogs.vue?vue&type=template&id=eb9ff02e&scoped=true&"
import script from "./WidgetsDialogs.vue?vue&type=script&lang=js&"
export * from "./WidgetsDialogs.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsDialogs.vue?vue&type=style&index=0&id=eb9ff02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9ff02e",
  null
  
)

export default component.exports